import { useTranslation } from 'react-i18next'
import { readEventlogHost } from '../../../types/analysis-artefacts'
import type { DecoratedArtefact } from './types'

interface EventlogHostCellProps {
  artefact: DecoratedArtefact
}

export function EventlogHostCell({ artefact }: EventlogHostCellProps): React.ReactElement {
  const { t } = useTranslation('analysis')
  const host = readEventlogHost(artefact.artefactType, artefact.extras)
  if (host === null) return <>{artefact.endpointId}</>
  return (
    <span className="inline-flex flex-wrap items-center gap-2">
      <span>{host.endpointHostname}</span>
      {host.computerMatch === 'mismatch' && (
        <span
          title={t('canvas.host.mismatchHint')}
          className="rounded px-1.5 py-0.5 text-xs"
          style={{
            color: 'var(--accent)',
            background: 'var(--accent-dim)',
            border: '1px solid var(--accent)',
          }}
        >
          {t('canvas.host.mismatch', { computer: host.computer ?? '' })}
        </span>
      )}
    </span>
  )
}
